//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as d3 from "d3";

export default {
  name: "VerticalBarsChart",
  props: [
    "id",
    "chartWidth",
    "chartHeight",
    "colorRange",
    "data",
    "margin",
    "valueLabel",
    "unitLabel",
    "showBackArrow",
    "isLoading"
  ],
  mounted: function () {
    this.renderChart();
  },
  computed: {
    total: function () {
      return this.data.children.reduce((accum, val) => accum + val.value, 0);
    },
  },
  watch: {
    "data.children": {
      immediate: true,
      deep: true,
      handler: function () {
        this.renderChart();
      },
    },
    chartWidth: {
      immediate: true,
      handler: function () {
        this.renderChart();
      },
    },
    chartHeight: {
      immediate: true,
      handler: function () {
        this.renderChart();
      },
    },
  },
  methods: {
    // FIXME
    // Make the chart responsive somehow.
    // Delete the casts.
    renderChart: function () {
      var width = Number(this.chartWidth);
      var height = Number(this.chartHeight);

      var margin = {
        top: Number(this.margin.top),
        right: Number(this.margin.right),
        bottom: Number(this.margin.bottom),
        left: Number(this.margin.left),
      };

      var colors = d3.scaleOrdinal().domain([1, 10]).range(this.colorRange);

      d3.selectAll(`#${this.id} > *`).remove();
      var svg = d3
        .select(this.$refs.treemap)
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      var root = d3.hierarchy(this.data).sum(function (d) {
        return d.value;
      });

      d3.treemap().size([width, height]).padding(2)(root);

      svg
        .selectAll("rect")
        .data(root.leaves())
        .enter()
        .append("rect")
        .attr("class", "graph-rectangle")
        .on("click", (_e, eventData) => {
          if (eventData.data.product_hierarchy_id != undefined) {
            this.$emit("clicked-hierarchy", {
              direction: "down",
              data: eventData.data,
            });
          }

          treemapTooltip.style("opacity", "0");
        })
        .on("contextmenu", (e, eventData) => {
          e.preventDefault();
          this.$emit("clicked-hierarchy", {
            direction: "up",
            data: eventData.data,
          });
        })
        .attr("x", function (d) {
          return d.x0;
        })
        .attr("y", function (d) {
          return d.y0;
        })
        .transition()
        .attr("width", function (d) {
          return d.x1 - d.x0;
        })
        .attr("height", function (d) {
          return d.y1 - d.y0;
        })
        .style("stroke", "black")
        .style("fill", (d) => colors(d.data.value / this.total))
        .duration(0);

      // var backArrow = svg.append("defs").append("g").attr("id", "back-arrow");

      // if (this.showBackArrow) {
      //   backArrow
      //     .append("path")
      //     .attr(
      //       "d",
      //       "M38,52a2,2,0,0,1-1.41-.59l-24-24a2,2,0,0,1,0-2.82l24-24a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82L16.83,26,39.41,48.59A2,2,0,0,1,38,52Z"
      //     );

      //   backArrow
      //     .append("rect")
      //     .attr("y", 72.72)
      //     .attr("width", 5)
      //     .attr("height", 5);

      //   svg
      //     .append("g")
      //     .append("use")
      //     .attr("xlink:href", "#back-arrow")
      //     .on("click", (_e) => {
      //       this.$emit("clicked-hierarchy", {
      //         direction: "up",
      //         data: this.data.children[0],
      //       });

      //       treemapTooltip.style("opacity", "0");
      //       _e.stopPropagation();
      //     });
      // }

      var treemapTooltip = d3
        .select("#treemap")
        .append("div")
        .attr("class", "tool-tip");

      svg
        .selectAll("rect")
        .on("mousemove", function (e, data) {
          this.$emit("clicked-hierarchy-data", {
            label: data.data.label,
            valueLabel: this.valueLabel,
            dataValue: d3.format(".3s")(data.data.value),
            unitLabel: this.unitLabel,
          });
        }.bind(this))
        .on("mouseout", function () {
          this.$emit("clicked-hierarchy-data", {
            label: "",
            valueLabel: "",
            dataValue: "",
            unitLabel: "",
          });
        }.bind(this));




      // svg
      //   .selectAll("rect")
      //   .on("mousemove", (e, data) => {
      //     treemapTooltip.style("left", e.clientX + 30 + "px");
      //     treemapTooltip.style("top", e.clientY - 40 + "px");
      //     treemapTooltip.style("opacity", "1");
      //     treemapTooltip.html(
      //       "" +
      //       "<div>" +
      //       "<div>Agregação: " +
      //       data.data.label +
      //       "</div>" +
      //       "<div>" +
      //       this.valueLabel +
      //       ": " +
      //       d3.format(".3s")(data.data.value) +
      //       " " +
      //       this.unitLabel +
      //       "</div>" +
      //       "</div>" +
      //       ""
      //     );
      //   })
      //   .on("mouseout", function () {
      //     treemapTooltip.style("opacity", "0");
      //   });

      // FIXME
      // Make text fit the area.
      // svg
      //   .selectAll("text")
      //   .data(root.leaves())
      //   .enter()
      //   .append("text")
      //   .attr("x", function (d) {
      //     return d.x0 + 5;
      //   })
      //   .attr("y", function (d) {
      //     return d.y0 + 20;
      //   })
      //   .text(function (d) {
      //     return d.data.label + " " + d3.format("~s")(d.data.value);
      //   })
      //   .attr("font-size", "15px")
      //   .attr("fill", "white");

      // svg
      //   .selectAll(".firstrow")
      //   .data(this.data)
      //   .enter()
      //   .append("circle")
      //   .attr("cx", function (d, i) {
      //     return 30 + i * 60;
      //   })
      //   .attr("cy", 50)
      //   .attr("r", 19)
      //   .attr("fill", function (d) {
      //     return colors(d);
      //   });
    },
    deleteText: function () {
      this.$emit("clicked-hierarchy-data", null);
    },
    climbHierarchy: function () {
      this.$emit("clicked-hierarchy", {
        direction: "up",
        data: this.data.children[0],
      });
    },
  },
};
